// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ProviderReviewsPage {
  background-color: #071414;
  min-height: 100vh;
}

.reviews-dashboard-error {
  background: rgba(220, 53, 69, 0.15);
  border: 1px solid rgba(220, 53, 69, 0.3);
  color: #ff6b6b;
  padding: 12px 16px;
  border-radius: 8px;
  margin-bottom: 20px;
}

.reviews-dashboard-grid {
  display: grid;
  grid-template-columns: 350px 1fr;
  gap: 24px;
  align-items: start;
}

@media (max-width: 1024px) {
  .reviews-dashboard-grid {
    grid-template-columns: 1fr;
  }
}

.stats-large-score {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px;
  background: rgba(255, 255, 255, 0.02);
  border: 1px solid rgba(255, 255, 255, 0.05);
  border-radius: 12px;
  margin-bottom: 24px;
}

.stats-score-value {
  font-size: 56px;
  font-weight: 800;
  color: #ffffff;
  line-height: 1;
}

.stats-stars-outer {
  margin: 12px 0 6px 0;
  font-size: 22px;
  color: #ffd700;
  letter-spacing: 2px;
}

.stats-total-reviews {
  font-size: 13.5px;
  color: rgba(255, 255, 255, 0.45);
}

.stars-distribution-container {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.distribution-row {
  display: flex;
  align-items: center;
  gap: 12px;
}

.dist-star-label {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.6);
  width: 28px;
}

.dist-bar-track {
  flex: 1 1;
  height: 8px;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 4px;
  overflow: hidden;
}

.dist-bar-fill {
  height: 100%;
  background: linear-gradient(135deg, #00f2fe 0%, #4facfe 100%);
  border-radius: 4px;
}

.dist-count-label {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.6);
  width: 24px;
  text-align: right;
}

.reviews-dashboard-empty {
  padding: 50px 10px;
  text-align: center;
  font-size: 14.5px;
  color: rgba(255, 255, 255, 0.4);
  font-style: italic;
}

.dashboard-reviews-list {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.dashboard-review-card {
  background: rgba(255, 255, 255, 0.02);
  border: 1px solid rgba(255, 255, 255, 0.05);
  border-radius: 12px;
  padding: 20px;
}

.dashboard-review-header {
  display: flex;
  align-items: center;
  gap: 14px;
  margin-bottom: 14px;
}

.review-author-avatar {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  object-fit: cover;
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.review-author-name {
  margin: 0 0 2px 0;
  font-size: 15px;
  font-weight: 600;
  color: #ffffff;
}

.review-date {
  font-size: 11.5px;
  color: rgba(255, 255, 255, 0.4);
}

.review-rating-stars {
  margin-left: auto;
  display: flex;
  gap: 2px;
}

.review-gold-star {
  color: #ffd700;
  font-size: 16px;
}

.review-comment-text {
  font-size: 14px;
  line-height: 1.55;
  color: rgba(255, 255, 255, 0.85);
  margin: 0 0 16px 0;
}

.review-photos-row {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 16px;
}

.review-thumbnail-img {
  width: 60px;
  height: 60px;
  border-radius: 6px;
  object-fit: cover;
  border: 1px solid rgba(255, 255, 255, 0.08);
}

/* Response Replies */
.review-dashboard-reply-block {
  background: rgba(90, 175, 154, 0.04);
  border-left: 3px solid #5aaf9a;
  padding: 14px 18px;
  border-radius: 0 10px 10px 0;
  margin-bottom: 16px;
}

.reply-badge {
  font-size: 11.5px;
  font-weight: 700;
  text-transform: uppercase;
  color: #5aaf9a;
  letter-spacing: 0.5px;
}

.reply-edit-btn {
  background: none;
  border: none;
  color: rgba(255, 255, 255, 0.45);
  font-size: 12px;
  cursor: pointer;
  padding: 0;
  transition: color 0.15s;
}

.reply-edit-btn:hover {
  color: #ffffff;
}

.reply-text {
  margin: 8px 0 0 0;
  font-size: 13.5px;
  color: rgba(255, 255, 255, 0.75);
  font-style: italic;
  line-height: 1.5;
}

/* Reply Input Box */
.reply-input-box {
  background: rgba(0, 0, 0, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 10px;
  padding: 16px;
  margin-bottom: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.reply-textarea-input {
  background: rgba(0, 0, 0, 0.25);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  padding: 12px;
  color: #ffffff;
  font-size: 13.5px;
  resize: vertical;
  font-family: inherit;
}

.reply-textarea-input:focus {
  outline: none;
  border-color: #00f2fe;
}

.reply-actions-row {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.reply-cancel-btn {
  background: transparent;
  border: 1px solid rgba(255, 255, 255, 0.15);
  color: rgba(255, 255, 255, 0.75);
  padding: 6px 14px;
  border-radius: 6px;
  font-size: 13px;
  cursor: pointer;
}

.reply-cancel-btn:hover {
  color: #ffffff;
}

.reply-submit-btn {
  background: #5aaf9a;
  border: none;
  color: #0c0f13;
  padding: 6px 16px;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
}

.reply-submit-btn:hover {
  opacity: 0.95;
}

/* Review Footer Actions */
.dashboard-review-footer {
  display: flex;
  gap: 16px;
  border-top: 1px solid rgba(255, 255, 255, 0.05);
  padding-top: 14px;
}

.footer-action-btn {
  background: transparent;
  border: none;
  color: rgba(255, 255, 255, 0.5);
  font-size: 13px;
  cursor: pointer;
  padding: 0;
  transition: color 0.15s;
}

.footer-action-btn:hover {
  color: #ffffff;
}

.footer-action-btn--flag:hover {
  color: #ff6b6b;
}

.flagged-indicator {
  font-size: 12.5px;
  color: #ff6b6b;
  font-style: italic;
}
`, "",{"version":3,"sources":["webpack://./src/Pages/ProviderReviewsPage/ProviderReviewsPage.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,mCAAmC;EACnC,wCAAwC;EACxC,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,qCAAqC;EACrC,2CAA2C;EAC3C,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,WAAW;AACb;;AAEA;EACE,SAAO;EACP,WAAW;EACX,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,6DAA6D;EAC7D,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,qCAAqC;EACrC,2CAA2C;EAC3C,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,0CAA0C;AAC5C;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,2CAA2C;AAC7C;;AAEA,qBAAqB;AACrB;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,kBAAkB;EAClB,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,gCAAgC;EAChC,eAAe;EACf,eAAe;EACf,UAAU;EACV,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,8BAA8B;EAC9B,2CAA2C;EAC3C,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,+BAA+B;EAC/B,0CAA0C;EAC1C,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,2CAA2C;EAC3C,gCAAgC;EAChC,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,SAAS;EACT,+CAA+C;EAC/C,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,+BAA+B;EAC/B,eAAe;EACf,eAAe;EACf,UAAU;EACV,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB","sourcesContent":[".ProviderReviewsPage {\n  background-color: #071414;\n  min-height: 100vh;\n}\n\n.reviews-dashboard-error {\n  background: rgba(220, 53, 69, 0.15);\n  border: 1px solid rgba(220, 53, 69, 0.3);\n  color: #ff6b6b;\n  padding: 12px 16px;\n  border-radius: 8px;\n  margin-bottom: 20px;\n}\n\n.reviews-dashboard-grid {\n  display: grid;\n  grid-template-columns: 350px 1fr;\n  gap: 24px;\n  align-items: start;\n}\n\n@media (max-width: 1024px) {\n  .reviews-dashboard-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n.stats-large-score {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 24px;\n  background: rgba(255, 255, 255, 0.02);\n  border: 1px solid rgba(255, 255, 255, 0.05);\n  border-radius: 12px;\n  margin-bottom: 24px;\n}\n\n.stats-score-value {\n  font-size: 56px;\n  font-weight: 800;\n  color: #ffffff;\n  line-height: 1;\n}\n\n.stats-stars-outer {\n  margin: 12px 0 6px 0;\n  font-size: 22px;\n  color: #ffd700;\n  letter-spacing: 2px;\n}\n\n.stats-total-reviews {\n  font-size: 13.5px;\n  color: rgba(255, 255, 255, 0.45);\n}\n\n.stars-distribution-container {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.distribution-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.dist-star-label {\n  font-size: 13px;\n  color: rgba(255, 255, 255, 0.6);\n  width: 28px;\n}\n\n.dist-bar-track {\n  flex: 1;\n  height: 8px;\n  background: rgba(255, 255, 255, 0.05);\n  border-radius: 4px;\n  overflow: hidden;\n}\n\n.dist-bar-fill {\n  height: 100%;\n  background: linear-gradient(135deg, #00f2fe 0%, #4facfe 100%);\n  border-radius: 4px;\n}\n\n.dist-count-label {\n  font-size: 13px;\n  color: rgba(255, 255, 255, 0.6);\n  width: 24px;\n  text-align: right;\n}\n\n.reviews-dashboard-empty {\n  padding: 50px 10px;\n  text-align: center;\n  font-size: 14.5px;\n  color: rgba(255, 255, 255, 0.4);\n  font-style: italic;\n}\n\n.dashboard-reviews-list {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.dashboard-review-card {\n  background: rgba(255, 255, 255, 0.02);\n  border: 1px solid rgba(255, 255, 255, 0.05);\n  border-radius: 12px;\n  padding: 20px;\n}\n\n.dashboard-review-header {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  margin-bottom: 14px;\n}\n\n.review-author-avatar {\n  width: 44px;\n  height: 44px;\n  border-radius: 50%;\n  object-fit: cover;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.review-author-name {\n  margin: 0 0 2px 0;\n  font-size: 15px;\n  font-weight: 600;\n  color: #ffffff;\n}\n\n.review-date {\n  font-size: 11.5px;\n  color: rgba(255, 255, 255, 0.4);\n}\n\n.review-rating-stars {\n  margin-left: auto;\n  display: flex;\n  gap: 2px;\n}\n\n.review-gold-star {\n  color: #ffd700;\n  font-size: 16px;\n}\n\n.review-comment-text {\n  font-size: 14px;\n  line-height: 1.55;\n  color: rgba(255, 255, 255, 0.85);\n  margin: 0 0 16px 0;\n}\n\n.review-photos-row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  margin-bottom: 16px;\n}\n\n.review-thumbnail-img {\n  width: 60px;\n  height: 60px;\n  border-radius: 6px;\n  object-fit: cover;\n  border: 1px solid rgba(255, 255, 255, 0.08);\n}\n\n/* Response Replies */\n.review-dashboard-reply-block {\n  background: rgba(90, 175, 154, 0.04);\n  border-left: 3px solid #5aaf9a;\n  padding: 14px 18px;\n  border-radius: 0 10px 10px 0;\n  margin-bottom: 16px;\n}\n\n.reply-badge {\n  font-size: 11.5px;\n  font-weight: 700;\n  text-transform: uppercase;\n  color: #5aaf9a;\n  letter-spacing: 0.5px;\n}\n\n.reply-edit-btn {\n  background: none;\n  border: none;\n  color: rgba(255, 255, 255, 0.45);\n  font-size: 12px;\n  cursor: pointer;\n  padding: 0;\n  transition: color 0.15s;\n}\n\n.reply-edit-btn:hover {\n  color: #ffffff;\n}\n\n.reply-text {\n  margin: 8px 0 0 0;\n  font-size: 13.5px;\n  color: rgba(255, 255, 255, 0.75);\n  font-style: italic;\n  line-height: 1.5;\n}\n\n/* Reply Input Box */\n.reply-input-box {\n  background: rgba(0, 0, 0, 0.2);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 10px;\n  padding: 16px;\n  margin-bottom: 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.reply-textarea-input {\n  background: rgba(0, 0, 0, 0.25);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 8px;\n  padding: 12px;\n  color: #ffffff;\n  font-size: 13.5px;\n  resize: vertical;\n  font-family: inherit;\n}\n\n.reply-textarea-input:focus {\n  outline: none;\n  border-color: #00f2fe;\n}\n\n.reply-actions-row {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n}\n\n.reply-cancel-btn {\n  background: transparent;\n  border: 1px solid rgba(255, 255, 255, 0.15);\n  color: rgba(255, 255, 255, 0.75);\n  padding: 6px 14px;\n  border-radius: 6px;\n  font-size: 13px;\n  cursor: pointer;\n}\n\n.reply-cancel-btn:hover {\n  color: #ffffff;\n}\n\n.reply-submit-btn {\n  background: #5aaf9a;\n  border: none;\n  color: #0c0f13;\n  padding: 6px 16px;\n  border-radius: 6px;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.reply-submit-btn:hover {\n  opacity: 0.95;\n}\n\n/* Review Footer Actions */\n.dashboard-review-footer {\n  display: flex;\n  gap: 16px;\n  border-top: 1px solid rgba(255, 255, 255, 0.05);\n  padding-top: 14px;\n}\n\n.footer-action-btn {\n  background: transparent;\n  border: none;\n  color: rgba(255, 255, 255, 0.5);\n  font-size: 13px;\n  cursor: pointer;\n  padding: 0;\n  transition: color 0.15s;\n}\n\n.footer-action-btn:hover {\n  color: #ffffff;\n}\n\n.footer-action-btn--flag:hover {\n  color: #ff6b6b;\n}\n\n.flagged-indicator {\n  font-size: 12.5px;\n  color: #ff6b6b;\n  font-style: italic;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
